import { render } from "./Transactions.vue?vue&type=template&id=195f84f1"
import script from "./Transactions.vue?vue&type=script&lang=js"
export * from "./Transactions.vue?vue&type=script&lang=js"
script.render = render

export default script